import React, { useState } from "react";
import { Button, Checkbox, message, Modal, Radio } from "antd";
import style from "./index.module.scss";
import { submitVotePaper, VotePaperInfo, VoteState, VoteType } from "API/vote";
import { useAsyncFn } from "react-use";
import { errorMessage } from "Utils/useRequest";
import { toNumber } from "Utils/filter";
import { useHistory } from "react-router-dom";

interface VoteQuestionProps {
    data: VotePaperInfo;
    onSuccess: () => void;
}

export default function VoteQuestion({ data, onSuccess }: VoteQuestionProps) {
    const history = useHistory();
    const { id: voteId, type, voteAnswerDomainList: options } = data;
    const disabled =
        data.status !== VoteState.InProgress || data.voteStatus === "1";
    const defaultValue =
        options
            .filter(item => item.changeStatus === "1")
            .map(item => item.id)
            .join(",") || "";
    const [value, setValue] = useState(defaultValue);

    const [status, callSubmitVotePaper] = useAsyncFn(submitVotePaper);

    async function onSubmit() {
        Modal.confirm({
            title: "确认提交选择?",
            content:
                "提交结果后，本次投票活动的选择内容将不可修改，请确认是否要提交选择？",
            cancelText: "取消",
            okText: "确认提交",
            onOk: async () => {
                const res = await callSubmitVotePaper(voteId, value);
                if (res.status !== 200)
                    return Modal.error({ content: errorMessage(res) });
                message.success("提交成功!");
                onSuccess();
            }
        });
    }

    return (
        <div className={style.root}>
            <div className={style.question}>
                {type === VoteType.Single && (
                    <Radio.Group
                        defaultValue={toNumber(defaultValue)}
                        onChange={val => setValue(val.target.value)}
                        disabled={disabled}>
                        {options.map(item => (
                            <Radio key={item.id} value={item.id}>
                                {item.content}
                            </Radio>
                        ))}
                    </Radio.Group>
                )}

                {type === VoteType.Multiple && (
                    <Checkbox.Group
                        defaultValue={defaultValue
                            .split(",")
                            .map(item => toNumber(item))}
                        onChange={val =>
                            setValue(val.map(item => item.valueOf()).join(","))
                        }
                        disabled={disabled}>
                        {options.map(item => (
                            <Checkbox key={item.id} value={item.id}>
                                {item.content}
                            </Checkbox>
                        ))}
                    </Checkbox.Group>
                )}

                {type === VoteType.Judge && (
                    <Radio.Group
                        defaultValue={
                            defaultValue ? toNumber(defaultValue) : -1
                        }
                        onChange={val => setValue(val.target.value)}
                        disabled={disabled}>
                        {options.map(item => (
                            <Radio key={item.id} value={item.id}>
                                {item.content}
                            </Radio>
                        ))}
                    </Radio.Group>
                )}
            </div>

            <div className={style.buttonWrapper}>
                {!disabled && (
                    <Button
                        type="primary"
                        className={style.button}
                        onClick={onSubmit}
                        loading={status.loading}
                        disabled={!value}>
                        提交选择
                    </Button>
                )}

                {disabled && (
                    <p className={style.tip}>
                        {data.voteStatus === "1" ? (
                            <span>您已提交投票，暂不支持重复提交投票</span>
                        ) : (
                            <span>投票活动已结束</span>
                        )}
                    </p>
                )}
            </div>
        </div>
    );
}
